function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "tommyLogo",
  transform: "translate(-7.000000, -10.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "g2997",
  transform: "translate(34.046051, 49.190798) scale(-1, 1) rotate(-180.000000) translate(-34.046051, -49.190798) translate(0.382761, 10.718467)",
  fill: "#00164E"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "path2999",
  points: "67.3265793 67.3265792 42.194529 67.3265792 42.194529 4.03959475 31.7589092 4.03959475 31.7589092 67.3265792 6.61724093 67.3265792 6.61724093 76.7042099 67.3265793 76.7042099"
})), /*#__PURE__*/React.createElement("g", {
  id: "g3001",
  transform: "translate(724.644552, 48.177052) scale(-1, 1) rotate(-180.000000) translate(-724.644552, -48.177052) translate(94.660132, 0.086638)"
}, /*#__PURE__*/React.createElement("g", {
  id: "g3003"
}, /*#__PURE__*/React.createElement("g", {
  id: "g3009",
  transform: "translate(2.180419, 11.669620)",
  fill: "#00164E",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M48.0904138,9.61808275 C64.3834459,9.61808275 76.4252855,21.4483245 76.4252855,37.308543 C76.4252855,53.2937965 64.3834459,65.0086213 48.0904138,65.0086213 C31.9031805,65.0086213 19.8613409,53.2937965 19.8613409,37.308543 C19.8613409,21.4483245 31.9031805,9.61808275 48.0904138,9.61808275 M48.0904138,74.5978498 C72.0490579,74.5978498 87.178302,57.5546072 87.178302,37.308543 C87.178302,17.7068903 72.4818716,0.0288542482 47.8691978,0.0288542482 C24.1221515,0.0288542482 9.10832436,17.6203276 9.10832436,37.308543 C9.10832436,57.4488083 24.5549653,74.5978498 48.0904138,74.5978498",
  id: "path3011"
})), /*#__PURE__*/React.createElement("g", {
  id: "g3013",
  transform: "translate(129.147768, 12.647779)",
  fill: "#00164E"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "path3015",
  points: "76.944662 0 66.5090422 0 66.5090422 56.5735627 66.2974444 56.5735627 43.9257839 28.4599069 42.2233833 28.4599069 19.8613409 56.5735627 19.640125 56.5735627 19.640125 0 9.20450519 0 9.20450519 72.6549971 19.0053315 72.6549971 43.0793926 42.8389406 67.2496346 72.6549971 76.944662 72.6549971"
})), /*#__PURE__*/React.createElement("g", {
  id: "g3017",
  transform: "translate(255.893901, 12.647779)",
  fill: "#00164E"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "path3019",
  points: "76.944662 0 66.5090422 0 66.5090422 56.5735627 66.2974444 56.5735627 43.9257839 28.4599069 42.2233833 28.4599069 19.8517228 56.5735627 19.640125 56.5735627 19.640125 0 9.20450519 0 9.20450519 72.6549971 19.0053315 72.6549971 43.0793926 42.8389406 67.2496346 72.6549971 76.944662 72.6549971"
})), /*#__PURE__*/React.createElement("g", {
  id: "g3021",
  transform: "translate(372.159209, 8.361961)",
  fill: "#00164E"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "path3023",
  points: "57.7084965 76.944662 70.2793307 76.944662 43.3294628 42.6465789 43.3294628 4.28966491 32.893843 4.28966491 32.893843 42.7523778 5.94397514 76.944662 18.5148093 76.944662 38.0010449 51.9184107"
})), /*#__PURE__*/React.createElement("g", {
  id: "g3025",
  transform: "translate(657.497908, 12.647779)",
  fill: "#00164E"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "path3027",
  points: "67.3265792 0 56.9005775 0 56.9005775 31.6531103 16.1968514 31.6531103 16.1968514 0 5.76123157 0 5.76123157 72.6549971 16.1968514 72.6549971 16.1968514 41.030741 56.9005775 41.030741 56.9005775 72.6549971 67.3265792 72.6549971"
})), /*#__PURE__*/React.createElement("polygon", {
  id: "path3029",
  fill: "#00164E",
  points: "778.506854 12.6477788 768.061616 12.6477788 768.061616 85.3027759 778.506854 85.3027759"
}), /*#__PURE__*/React.createElement("g", {
  id: "g3031",
  transform: "translate(812.523127, 12.418868)",
  fill: "#00164E"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "path3033",
  points: "19.2361655 9.61808275 52.0434458 9.61808275 52.0434458 0.230833986 8.80054572 0.230833986 8.80054572 72.8858311 19.2361655 72.8858311"
})), /*#__PURE__*/React.createElement("g", {
  id: "g3035",
  transform: "translate(885.217558, 8.604337)",
  fill: "#00164E"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "path3037",
  points: "48.0904138 67.3265792 19.755542 67.3265792 19.755542 47.1959321 48.0904138 47.1959321 48.0904138 37.8279195 19.755542 37.8279195 19.755542 4.03959475 9.32954027 4.03959475 9.32954027 76.7042099 48.0904138 76.7042099"
})), /*#__PURE__*/React.createElement("polygon", {
  id: "path3039",
  fill: "#00164E",
  points: "980.274994 12.6477788 969.848992 12.6477788 969.848992 85.3027759 980.274994 85.3027759"
}), /*#__PURE__*/React.createElement("g", {
  id: "g3041",
  transform: "translate(1012.322446, 8.053221)",
  fill: "#00164E"
}, /*#__PURE__*/React.createElement("path", {
  d: "M67.3265793,9.61808275 C57.6219338,5.35727209 49.7639601,3.64525336 39.6457371,3.64525336 C17.3798755,3.64525336 0.971426358,19.2073113 0.971426358,40.5113645 C0.971426358,61.9115987 17.8030712,78.2142489 39.9438977,78.2142489 C48.4751371,78.2142489 54.4479664,76.829245 65.8357764,72.0298217 L65.8357764,61.4980211 C57.3237732,66.1724093 48.4751371,68.6250204 39.7322998,68.6250204 C23.9682622,68.6250204 11.734061,56.5927989 11.734061,40.8287613 C11.734061,24.6319099 23.8624633,13.2344819 41.1269218,13.2344819 C46.7631183,13.2344819 51.8799384,14.5136869 56.8909595,16.1102886 L56.8909595,31.027935 L42.9255033,31.027935 L42.9255033,40.3959475 L67.3265793,40.3959475 L67.3265793,9.61808275 Z",
  id: "path3043"
})), /*#__PURE__*/React.createElement("g", {
  id: "g3045",
  transform: "translate(1112.505357, 8.604337)",
  fill: "#00164E"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "path3047",
  points: "48.0904138 67.3265792 17.312549 67.3265792 17.312549 45.3877325 47.0228066 45.3877325 47.0228066 36.0197199 17.312549 36.0197199 17.312549 13.4364616 49.052222 13.4364616 49.052222 4.03959475 6.86731108 4.03959475 6.86731108 76.7042099 48.0904138 76.7042099"
})), /*#__PURE__*/React.createElement("g", {
  id: "g3049",
  transform: "translate(1188.441082, 5.479422)",
  fill: "#00164E",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M19.2361655,48.0904137 L25.9399692,48.0904137 C37.1257994,48.0904137 40.3190029,53.8324092 40.2228221,59.9014194 C40.097787,66.7302581 36.0581922,70.8756518 25.9399692,70.8756518 L19.2361655,70.8756518 L19.2361655,48.0904137 Z M27.1037572,79.8300868 C41.8001876,79.8300868 50.9662205,72.0490579 50.9662205,59.4878418 C50.9662205,51.0624013 46.609229,44.7817933 38.8282001,41.6943887 C45.4262048,37.3277792 49.4850357,30.6239755 55.0154333,21.5637415 C58.112456,16.5527204 59.9110374,14.1097274 64.9316766,7.16547165 L52.4666414,7.16547165 L42.8774129,22.1023542 C33.2881844,37.0103824 28.9215748,38.7127831 23.6123932,38.7127831 L19.2361655,38.7127831 L19.2361655,7.16547165 L8.79092763,7.16547165 L8.79092763,79.8300868 L27.1037572,79.8300868 Z",
  id: "path3051"
})), /*#__PURE__*/React.createElement("polygon", {
  id: "path3083",
  fill: "#E31937",
  points: "604.121396 67.2592527 548.259571 67.2592527 548.259571 30.8163371 604.121396 30.8163371"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "path3085",
  fill: "#FFFFFF",
  points: "548.259571 67.1534538 492.407364 67.1534538 492.407364 30.8163371 548.259571 30.8163371"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "path3087",
  fill: "#00285D",
  points: "492.397746 85.2931578 604.121396 85.2931578 604.121396 67.2111623 492.397746 67.2111623"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "path3089",
  fill: "#00285D",
  points: "492.397746 30.922136 604.121396 30.922136 604.121396 12.7535777 492.397746 12.7535777"
})))));

var SvgTommyLogo = function SvgTommyLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1341px",
    height: "75px",
    viewBox: "0 0 1341 75",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTommyLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/tommyLogo.0f2b3cba.svg";
export { ForwardRef as ReactComponent };